import { MenuItem } from '../../interfaces/menu';

export const menuList: MenuItem[] = [
  {
    title: 'מסך הבית',
    icon: 'home',
    route: 'home'
  },
  {
    title: 'אקדמיה',
    icon: 'academic',
    route: '',
    subMenu: [
      {
        title: 'מערכת שעות וקורסים',
        route: '#'
      },
      {
        title: 'בחינות ומטלות',
        route: '#'
      },
      {
        title: 'הציונים שלי',
        route: '#'
      },
      {
        title: 'קטלוג מלגות',
        route: '#'
      },
      {
        title: 'קטלוג תכניות מצטיינים',
        route: '#'
      }
    ]
  },
  {
    title: 'שכר לימוד ותשלומים ',
    icon: 'payment',
    route: '#'
  },
  {
    title: 'בקשות ותהליכים',
    icon: 'process',
    route: '#'
  },
  {
    title: `עבודה וקריירה`,
    icon: 'career',
    route: '#'
  },
  {
    title: 'שירותים לסטודנטי.ית',
    icon: 'student',
    route: '#'
  },
  {
    title: 'נהלים וזכויות',
    icon: 'procedures',
    route: '#'
  },
  {
    title: 'מידע מחלקתי',
    icon: 'info',
    route: '#'
  }
];
